import React from 'react';
import { createRoot } from 'react-dom/client';

import * as Sentry from '@sentry/react';

import App from './App';

export const { NODE_ENV = 'production', SENTRY_SDK_URL_ADMIN = '' } =
  process.env;

if (['demo', 'staging', 'production'].includes(NODE_ENV)) {
  Sentry.init({
    dsn: SENTRY_SDK_URL_ADMIN,
    sendDefaultPii: true,
    environment: NODE_ENV,
  });
}

createRoot(document.getElementById('app')).render(<App />);
